import { render, staticRenderFns } from "./spotlightLight.vue?vue&type=template&id=76be7a69"
import script from "./spotlightLight.vue?vue&type=script&lang=js"
export * from "./spotlightLight.vue?vue&type=script&lang=js"
import style0 from "./spotlightLight.vue?vue&type=style&index=0&id=76be7a69&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports